import { Application, EntryPoint } from '@wellesley/openapi'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { userSlice } from '@wellesley/user/slices/userSlice'
import { getEntryAppRoute } from '@wellesley/router'

export const useGetAppLink = ({ entryPoint }: { entryPoint: EntryPoint }) => {
  const currentUser = useSelector(userSlice.selectors.selectCurrentUser)
  const username = currentUser?.username || undefined

  const getLink = useCallback(
    (app: Application, groupname?: string) =>
      getEntryAppRoute({
        id: app.id,
        routes: app.manifest.routes ?? [],
        username,
        groupname: groupname || undefined,
        entryPoint,
      }),
    [entryPoint, username],
  )

  return getLink
}
